import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useMemo } from 'react';
import { ThemeProvider as StyledComponentsThemeProvider } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
var INITIAL_THEME_SECTION = 'page';
function ThemeProvider(_ref) {
  var theme = _ref.theme,
    children = _ref.children;
  var globalTheme = useMemo(function () {
    var pageSection = theme.sections[INITIAL_THEME_SECTION];
    if (!pageSection) {
      throw Error("Couldn't find a '".concat(INITIAL_THEME_SECTION, "' section in provided global theme."));
    }
    return _objectSpread(_objectSpread(_objectSpread({}, theme), pageSection), {}, {
      currentThemeSectionName: INITIAL_THEME_SECTION,
      parentThemeSectionName: null
    });
  }, [theme]);
  return /*#__PURE__*/_jsx(StyledComponentsThemeProvider, {
    theme: globalTheme,
    children: children
  });
}
export default ThemeProvider;